import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography, Button, Stack, useMediaQuery } from "@mui/material";
import { useTranslation } from 'react-i18next';
import BackgroundImage from '../assets/plus_top_picture.png';

import { paths } from 'routes';

export const TopSection = () => {
  const { t } = useTranslation();
  const boxRef = useRef(null);
  const [boxInnerHeight, setBoxInnerHeight] = useState(0);

  useEffect(() => {
    function updateHeight() {
      if (boxRef.current) {
        setBoxInnerHeight(boxRef.current.offsetHeight);
      }
    }

    updateHeight();
    window.addEventListener('resize', updateHeight);

    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

  const isXs = useMediaQuery('(max-width: 899px)');
  const isSmallMd = useMediaQuery('(min-width: 900px) and (max-height: 700px)');

  const xsStylesBody = {
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: 1.5,
  };

  const mdStylesBody = {
    fontSize: '1.25rem',
    fontWeight: 500,
    lineHeight: 1.55,
  };

  const xsStylesH = {
    fontSize: '2rem',
    fontWeight: 600,
    lineHeight: 1.15,
    overflowWrap: 'anywhere',
    width: '100%',
    minWidth: 0,
  };

  const mdStylesH = {
    fontSize: '3.5rem',
    fontWeight: 700,
    lineHeight: 1.25,
    overflowWrap: 'anywhere',
    width: '100%',
    minWidth: 0,
  };

  const bodyStyles = isXs || isSmallMd ? xsStylesBody : mdStylesBody;
  const hStyles = isXs || isSmallMd ? xsStylesH : mdStylesH;
  const boxHeight = isXs || isSmallMd ? "auto" : 398;

  return (
    <Box
      display={"flex"}
      sx={{
        position: "relative",
        width: "100vw",
        height: [
          "calc(100dvh - 70px)",
          "calc(100dvh - 70px - constant(safe-area-inset-bottom))",
          "calc(100dvh - 70px - env(safe-area-inset-bottom, 0px))"
        ],
        marginLeft: { md: "-50vw" },
        left: { md: "50%" },
      }}
    >
        <img
          className="small-logo"
          src={BackgroundImage}
          alt={'BackgroundImage'}
          // loading="lazy"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
        <Box
          display={"flex"}
          ref={boxRef}
          sx={{
            maxWidth: {xs: "392px", md: "650px"},
            minHeight: {xs: "auto", md: boxHeight},
            p: {xs: 3, md:"50px"},
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 3.25,
            borderRadius: "0px 30px 30px 0",
            background: "rgba(237, 243, 253, 0.8)",
            position: "absolute",
            top: {
              xs: '50%',
              md: `calc((100vh - 70px - env(safe-area-inset-bottom) - ${boxInnerHeight}px) / 2)`,
            },
            left: 0,
            transform: { xs: 'translateY(-50%)', md: 'none' },
          }}
        >
          <Typography variant="h2" sx={hStyles} color="#000B0D">
            {t('website:plus.topSection.heading')}
          </Typography>
          <Box>
            <Typography variant="body2" sx={bodyStyles} color="#000B0D">
              {t('website:plus.topSection.description1')}
            </Typography>
            <Typography variant="body2" sx={bodyStyles} color="#000B0D">
              {t('website:plus.topSection.description2')}
            </Typography>
          </Box>
          <Stack width={1}>
            <Button
              size="medium"
              variant="contained"
              component="a"
              href={paths.auth.register}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                backgroundColor: "#62A7B7",
                '&:hover': {
                  backgroundColor: "#62A7B7",
                },
                minWidth: 200,
                whiteSpace: 'nowrap',
                height: 48,
                fontSize: "1rem",
                fontWeight: "700",
                color: "#fff",
                lineHeight: 1.5,
                alignSelf: "center",
              }}
            >
              {t('website:plus.topSection.ctaButton')}
            </Button>
          </Stack>
        </Box>
    </Box>
  )
}